<ng-container *transloco="let t; read: 'formFieldDate'">
  <ng-container *ngIf="field.readonly === true">
    <crm-row>
      <header>{{ field.name }}</header>
      <main>{{ readonlyValue$ | async | date: 'shortDate' }}</main>
    </crm-row>
  </ng-container>

  <ng-container *ngIf="!field.readonly" [formGroup]="parentFormGroup">
    <mat-form-field class="form-field">
      <mat-label>{{ field.name }}</mat-label>
      <input
        type="text"
        matInput
        [formControlName]="field.key"
        [matDatepickerFilter]="minMaxFilter"
        [matDatepicker]="date"
        readonly
        [required]="parentFormGroup.get(field.key).errors?.required"
      />
      <mat-datepicker #date></mat-datepicker>
      <button
        *ngIf="showClearButton"
        (click)="clearField($event)"
        class="clear"
        matSuffix
        mat-icon-button
        aria-label="Clear"
        type="button"
      >
        <mat-icon>close</mat-icon>
      </button>
      <mat-datepicker-toggle
        matSuffix
        [for]="date"
        data-qa="btn-toggle-datepicker"
      ></mat-datepicker-toggle>

      <span matPrefix>
        <ng-content select="[prefix]"></ng-content>
      </span>

      <span matSuffix>
        <ng-content select="[suffix]"></ng-content>
      </span>

      <mat-error [ngxErrors]="field.key" #error="ngxErrors">
        <span ngxError="required">{{ t('requiredField') }}</span>
        <span ngxError="min">
          {{ t('dateMustBeAtLeast', { min: error.getError('min')?.min }) }}
        </span>
        <span ngxError="max">{{ t('dateMustBeNoMore', { max: error.getError('max')?.max }) }}</span>
        <span ngxError="backend">{{ error.getError('backend') }}</span>
      </mat-error>
    </mat-form-field>
  </ng-container>
</ng-container>
